<template>
   <fragment>
      <TopNav />
      <main role="main" class="container">
         <br /><br />

         <div class="row">
            <!-- FILTERS COLUMN -->
            <div class="col-lg-3">
               <FilterGroups ref="filterGroups" @load-domains="loadDomains" :show-domains="true" />
            </div>
            <!-- end FILTERS -->

            <!-- RESULTS COLUMN -->
            <div class="col-lg-9">
               <div class="row">
                  <div class="sticky-too">
                     <!-- RESULTS HEADER -->
                     <div class="col-md-12 mb-3 results-header">
                        <h1 v-if="!isFiltered" aria-label="Top level job categories">
                           Narrow your search by selecting your key competencies.
                        </h1>
                        <FilterButtons v-else>
                           &nbsp;
                           <!-- prevent bounce when toggling filters off -->
                        </FilterButtons>
                     </div>
                  </div>

                  <!-- RESULT CARDS -->
                  <div class="col-md-12 card-list-container card-category" role="list">
                     <div v-if="loadingDomains" class="empty">
                        <div class="spinner-border text-secondary" role="status">
                           <span class="sr-only">Loading</span>
                        </div>
                        <h1>Loading</h1>
                     </div>
                     <div v-else class="row row-cols-1 row-cols-md-3 card-deck">
                        <CategoryCard
                           v-for="jobDomain in jobDomains"
                           :key="jobDomain.jobDomainId"
                           :job-domain="jobDomain"
                        />
                     </div>
                  </div>
               </div>
            </div>
            <!-- end CARDS -->
         </div>
      </main>
   </fragment>
</template>
<script>
import {debounce, filter} from 'lodash';
import {stringify} from 'query-string';
import TopNav from '@/components/TopNav';
import FilterGroups from '@/components/FilterGroups';
import CategoryCard from '@/components/CategoryCard';
import FilterButtons from '@/components/FilterButtons';

export default {
   name: 'CategoriesPage',
   components: {
      TopNav,
      FilterGroups,
      CategoryCard,
      FilterButtons,
   },
   data: function() {
      return {
         jobDomains: [],
         careers: [],
         loadingDomains: true,
         isFiltered: false,
      };
   },
   created: function() {
      // watch Vuex for changes to the store (filters)
      this.unwatch = this.$store.watch(
         (state, getters) => [getters['filters/filterParams'], getters['filters/noFilters']],
         debounce(async watched => {
            const query = watched[0];
            const empty = watched[1];
            const search = stringify(query);

            this.isFiltered = !empty;
            // show loading indicator on category cards
            // TODO: this isn't working; for some reason, loadingCareers=true is
            // only recognized by the subcomponent on startup; it responds to a
            // change to false but not a subsequent change to true
            this.jobDomains.forEach(domain => {
               this.$set(domain, 'loadingCareers', true);
            });

            // update the URL to reflect selected filters and allow bookmarking
            try {
               this.$router.push({path: 'categories', query});
            } catch (e) {}
            // update the search results using the API
            try {
               this.careers = (await this.$apiGet(`Careers/Find?${search}`)).data;
            } catch (e) {
               this.careers = [];
               if (e.response.status === 404) {
                  console.debug('no results');
               }
            }

            this.updateCounts(!empty, search);
         }, 500)
      );
   },
   beforeDestroy: function() {
      this.unwatch();
   },
   methods: {
      loadDomains: function(domains) {
         this.jobDomains = domains.map(domain => {
            domain['loadingCareers'] = true;
            return domain;
         });
         this.loadingDomains = false;
      },
      updateCounts: function(filtered, queryString) {
         this.isFiltered = filtered;
         const groups = this.$refs.filterGroups;
         if (!groups) return;
         groups.isFiltered = filtered;
         groups.resultCount = 0;
         groups.resultCount = this.careers.length;

         for (let i = 0; i < this.jobDomains.length; ++i) {
            const domain = this.jobDomains[i];
            const careersForDomain = filter(this.careers, ['jobDomain', domain.jobDomain1]);
            this.$set(domain, 'loadingCareers', false);
            this.$set(domain, 'careerCount', careersForDomain.length);
            this.$set(
               domain,
               'careerUrl',
               `careers?jobDomain=${domain.jobDomainId}&${queryString}`
            );
         }
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/CategoriesPage.vue